import { isEmpty } from 'lodash'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { buildAbilityFor } from '../../configs/acl'
import { useAuth } from '../../hooks/useAuth'
import { AbilityContext } from '../../layouts/components/acl/Can'
import NotAuthorized from '../../pages/Page401'


const AclGuard = props => {
  // ** Props
  const { aclAbilities, children, guestGuard } = props
  const [ability, setAbility] = useState(undefined)

  // ** Hooks
  const auth = useAuth()
  const location = useLocation();

  // If guestGuard is true and user is not logged in or its an error page, render the page without checking access
  if (guestGuard || location.pathname === '/404' || location.pathname === '/500' || location.pathname === '/') {
    return <>{children}</>
  }

  // User is logged in, build ability for the user based on his role
  if (auth.user && auth.user.role && !ability) {
    setAbility(buildAbilityFor(auth.user.role, aclAbilities.subject))
  }

  // Check the access of current user and render pages
  if (ability && ability.can(aclAbilities.action, aclAbilities.subject)) {
    return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>
  }

  // Render Not Authorized component if the current user has limited access
  return (
    <NotAuthorized />
  )
}

export default AclGuard
